
































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  dispatchType = "sensitive/list";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "敏感词", dataIndex: "word" },
    { title: "时间", dataIndex: "created_time" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();
  }
}
